import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContentProvider';
import axiosClient from '../axios-client.js';

import logo from '../images/logo-black.png';
import BellIcon from './notifications/BellIcon';
import Modal from 'react-bootstrap/Modal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';

export default function DefaultLayout() {
  const { setUser, getUser, setToken, getToken } = useStateContext();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const token = getToken();
  const user = getUser();

  const onLogout = (ev) => {
    ev.preventDefault();
    axiosClient.post('/logout').then(() => {
      setUser({});
      setToken(null);
      navigate('/auth/login');
    });
  };

  return (
    <div>
      {/* ── Header ───────────────────────────────────────────── */}
      <nav id="psycle" className="navbar fixed-top">
        <div className="psycle-header-inner">
          {/* Logo — centered via absolute positioning */}
          <Link to="/" className="psycle-header-logo">
            <img className="logo" src={logo} alt="Psycle" />
          </Link>

          {/* Primary actions + hamburger — pushed to the right */}
          <div className="psycle-header-actions">
            {/* Desktop-only actions */}
            <div className="psycle-desktop-actions">
              {!token ? (
                <Link to="/auth/login" className="psycle-nav-btn text-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                  </svg>
                  Iniciar Sesión
                </Link>
              ) : (
                <>
                  <Link to="/perfil" className="psycle-nav-btn text-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                    </svg>
                    Perfil
                  </Link>
                  <Link to="/reservar-clases" className="psycle-nav-btn outlined">Reservar Clases</Link>
                  <Link to="/comprar-clases"  className="psycle-nav-btn filled">Comprar Clases</Link>
                </>
              )}
            </div>

            {/* Bell always visible when logged in */}
            {token && <BellIcon userId={user?.id} />}

            {/* Hamburger */}
            <button
              className="psycle-hamburger"
              onClick={() => setShowMenu(true)}
              aria-label="Menú"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      {/* ── Offcanvas sidebar ────────────────────────────────── */}
      <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img className="logo" src={logo} alt="Psycle" style={{ width: 100 }} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          <Nav className="flex-column gap-1 flex-grow-1">
            {/* Mobile-only primary actions */}
            {!token ? (
              <Nav.Link as={Link} to="/auth/login" onClick={() => setShowMenu(false)} className="d-xl-none">
                Iniciar Sesión
              </Nav.Link>
            ) : (
              <>
                <Nav.Link as={Link} to="/perfil"           onClick={() => setShowMenu(false)} className="d-xl-none">Perfil</Nav.Link>
                <Nav.Link as={Link} to="/reservar-clases"  onClick={() => setShowMenu(false)} className="d-xl-none">Reservar Clases</Nav.Link>
                <Nav.Link as={Link} to="/comprar-clases"   onClick={() => setShowMenu(false)} className="d-xl-none">Comprar Clases</Nav.Link>
                <hr className="d-xl-none my-1" />
              </>
            )}

            {token && (
              <Nav.Link as={Link} to="/mis-clases"  onClick={() => setShowMenu(false)}>Mis Clases</Nav.Link>
            )}
            {/* <Nav.Link as={Link} to="/sobre-psycle"          onClick={() => setShowMenu(false)}>Sobre Psycle</Nav.Link> */}
            {/* <Nav.Link as={Link} to="/coaches"                onClick={() => setShowMenu(false)}>Coaches</Nav.Link> */}
            <Nav.Link as={Link} to="/preguntas-frecuentes"  onClick={() => setShowMenu(false)}>Preguntas Frecuentes</Nav.Link>

            {(user?.role === 'staff' || user?.role === 'admin') && (
              <Nav.Link as={Link} to="/panel" onClick={() => setShowMenu(false)}>Panel</Nav.Link>
            )}
            {user?.role === 'admin' && (
              <Nav.Link as={Link} to="/admin" onClick={() => setShowMenu(false)}>Admin</Nav.Link>
            )}
          </Nav>

          {token && (
            <div className="d-flex align-items-center justify-content-end pt-3 border-top mt-3">
              <Nav.Link href="#" onClick={onLogout} className="text-danger fw-semibold">
                Cerrar Sesión
              </Nav.Link>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* ── Main content ─────────────────────────────────────── */}
      <Outlet />

      {/* ── Footer ───────────────────────────────────────────── */}
      <footer className="footer-section">
        <div className="links container">
          <div>
            <p>Redes Sociales</p>
            <div className="red-logo-cont">
              <a href="https://facebook.com/profile.php?id=100088835658679" target="_blank" rel="noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FFF" className="bi bi-facebook red-logo" viewBox="0 0 16 16">
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
                </svg>
              </a>
              <a href="https://instagram.com/psycle.mx?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FFF" className="bi bi-instagram red-logo" viewBox="0 0 16 16">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <p className="link-footer" onClick={() => setShowPrivacy(true)}>Aviso de privacidad</p>
          </div>
        </div>
      </footer>

      {/* ── Privacy modal ─────────────────────────────────────── */}
      <Modal show={showPrivacy} onHide={() => setShowPrivacy(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Aviso de Privacidad</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            El presente Política de Privacidad establece los términos en que Psycle usa y protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio web. Esta compañía está comprometida con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin embargo esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.

            Información que es recogida

            Nuestro sitio web podrá recoger información personal por ejemplo: Nombre, información de contacto como su dirección de correo electrónica e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para procesar algún pedido o realizar una entrega o facturación.

            Uso de la información recogida

            Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, de pedidos en caso que aplique, y mejorar nuestros productos y servicios. Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con ofertas especiales, nuevos productos y otra información publicitaria que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento.

            Psycle está altamente comprometido para cumplir con el compromiso de mantener su información segura. Usamos los sistemas más avanzados y los actualizamos constantemente para asegurarnos que no exista ningún acceso no autorizado.

            Cookies

            Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente. Otra función que tienen las cookies es que con ellas las web pueden reconocerte individualmente y por tanto brindarte el mejor servicio personalizado de su web.

            Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo las cookies ayudan a proporcionar un mejor servicio de los sitios web, estás no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente. Usted puede aceptar o negar el uso de cookies, sin embargo la mayoría de navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.

            Enlaces a Terceros

            Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de su interés. Una vez que usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.

            Control de su información personal

            En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web. Cada vez que se le solicite rellenar un formulario, como el de alta de usuario, puede marcar o desmarcar la opción de recibir información por correo electrónico. En caso de que haya marcado la opción de recibir nuestro boletín o publicidad usted puede cancelarla en cualquier momento.

            Esta compañía no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial.

            Psycle Se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPrivacy(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}